import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/pt';
export const locale = {
  lang: 'pt',
  data: {
    'VOICE': {
      'ENABLE': 'Habilitar trilhas de áudio para pesquisa',
      'TITULO': 'Configurações de voz',
      'SUBTITULO': 'Esta configuração só será aplicada se as trilhas de áudio da pesquisa estiverem habilitadas.',
      'CONFIG_IDIOMA': {
        'TITULO': 'Configurações atuais para este idioma',
        'GENERO': {
          'TITULO': 'Gênero de voz',
          'Femenino': 'Fêmea',
          'Masculino': 'Masculino'
        },
        'TIPO_VOZ': {
          'TITULO': 'Tipo de voz',
          '1': 'Voz tipo 1',
          '2': 'Voz tipo 2',
          '3': 'Voz tipo 3',
          '4': 'Voz tipo 4',
          '5': 'Voz tipo 5',
          '6': 'Voz tipo 6',
          '7': 'Voz tipo 7',
          '8': 'Voz tipo 8',
          '9': 'Voz tipo 9',
          '10': 'Voz tipo 10',
        },
        'PRUEBA_VOZ': {
          'TITULO': 'Teste de voz',
          'INSTRUCCION': 'Escreva um texto para testar a voz',
          'PLACEHOLDER': 'Texto de teste de voz',
          'PROBAR': 'Teste de texto para fala'
        }
      },
      'MODALES': {
        'COMPLETAR': 'Tem certeza de que concluiu a etapa com a seleção de voz atual?',
        'COMPLETAR_OFF': 'Tem certeza de que deseja concluir a etapa com as configurações de voz desativadas?',
        'INCOMPLETO': 'Você ainda não fez a seleção completa de vozes em todos os idiomas, é necessário completá-la para continuar',
        'PASO_COMPLETO': 'Etapa completada com sucesso',
        'GENERANDO_AUDIOS': 'As configurações de voz estão sendo aplicadas a seções deste produto, aguarde um momento'
      }
    }
  }
};
